import { handleActions } from 'redux-actions'

import * as flashActions from '../actions/flash'

const defaultValue = false

export default handleActions(
  {
    [flashActions.onFlashProgressStateUpdate.toString()](
      state,
      action: ReturnType<typeof flashActions.onFlashProgressStateUpdate>
    ) {
      return action.payload
    },
  },
  defaultValue
)
